import styled from 'styled-components'
import Link from 'next/link'

import { hcData } from 'lib/CCAQuery'
import { FlexRowDiv, FlexDiv, Box, H1, P, A } from 'components/generic/HomePageComponents'
import AboutUs from './AboutUs'
import Features from './Features'
import EasyEffectiveAffordable from './EasyEffectiveAffordable'
import Pricing from './Pricing'
import Reviews from './Reviews'

export const CCAButton = styled(A)`
  background-color: ${(props) => props.theme.colors.inverseColor};
  transition: background-color 0.5s ease;
  width: 200px;
  padding: 10px 48px;
  font-weight: bold;
  white-space: normal;
  font-size: 25px;
  margin-top: 35px;
  border: 2px #fff solid;
  text-decoration: none;
  color: ${(props) => props.theme.colors.buttonColor};
  border-radius: 5px;
  text-align: center;
  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.inverseColor};
    border-color: ${(props) => props.theme.colors.inverseColor};
  }
`

const HeroPanel = (props) => {
  const {
    data: {
      backgroundImageDesktop,
      backgroundImageMobile,
      header,
      body,
      buttonCta,
      buttonLink,
      jobSeeker,
      jobSeekerLink,
      jobSeekerLinkText,
    },
  } = props
  const desktopImageUrl = `url(${backgroundImageDesktop})`
  const mobileImageUrl = `url(${backgroundImageMobile})`
  return (
    <FlexRowDiv
      pt={{ _: '100px', tablet: '0' }}
      backgroundImage={{ _: mobileImageUrl, tablet: desktopImageUrl }}
      backgroundPosition={{ _: '50% 0px', tablet: 'center center' }}
      backgroundRepeat='no-repeat'
      backgroundSize='cover'
      borderBottom='1px grey solid'
      minHeight={{ _: '1200px', tablet: '600px' }}
      className='CCA'
    >
      <FlexRowDiv
        justifyContent={{ _: 'flex-start', tablet: 'flex-end' }}
        ml={{ _: '0', tablet: 'auto' }}
        mr={{ _: '0', tablet: 'auto' }}
        maxWidth='1259px'
        flexDirection={{ _: 'column', tablet: 'row' }}
      >
        <FlexDiv
          flexDirection='column'
          width={{ _: '100%', tablet: '50%' }}
          m='80px 0px 40px 40px'
          mt={{ _: '0', tablet: '80px' }}
        >
          <H1 fontSize='38px' mb='10px' lineHeight='1.2' maxWidth={{ _: '80vw', tablet: '' }}>
            {header}
          </H1>
          <P maxWidth={{ _: '80vw', tablet: '550px' }} fontSize='23px' lineHeight='1.3'>
            {body}
          </P>
          <Box mt='20px'>
            <CCAButton href={buttonLink}>{buttonCta}</CCAButton>
            <Box display='flex' mt='40px'>
              <P fontSize='18px' mt='0px'>
                {jobSeeker}
              </P>
              <Link href={jobSeekerLink} passHref={true}>
                <A color='inverseColor' fontSize='18px'>
                  {jobSeekerLinkText}
                </A>
              </Link>
            </Box>
          </Box>
        </FlexDiv>
      </FlexRowDiv>
    </FlexRowDiv>
  )
}
export default function CCAMainContainer(props) {
  return (
    <>
      <HeroPanel data={hcData.heroPanel} />
      <AboutUs data={hcData.aboutUs} />
      <Features data={hcData.features} />
      <EasyEffectiveAffordable data={hcData.easyEffectiveAffordable} />
      <Pricing data={hcData.pricing} wave={hcData.features.waveImage} />
      <Reviews data={hcData.reviews} wave={hcData.features.waveImage} />
    </>
  )
}
